import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import { Container, Box, CssBaseline } from "@mui/material";
import { AppProvider } from "../context/AppContext";
import { CartProvider } from "../context/CartContext";
import { ClubHeader } from "./ClubHeader";
import { Footer } from "./Footer";
import theme from "../services/theme";
import { Outlet } from "react-router-dom";

export const Layout = (props) => {
  return (
    <ThemeProvider theme={theme}>
      <AppProvider>
        <CartProvider>
          <CssBaseline />
          <ClubHeader />
          <Container
            maxWidth="md"
            sx={{
              pt: 8,
              px: 0,
              mt: 0,
              display: "flex",
              flexDirection: "column",
              minHeight: "100vh",
            }}
          >
            <Box sx={{ flexGrow: 1 }}>
              <Outlet />
            </Box>
            <Footer />
          </Container>
        </CartProvider>
      </AppProvider>
    </ThemeProvider>
  );
};
